import { DayOfWeek, LocalDate, TemporalAdjusters } from '@js-joda/core';
import { FormattedDate } from 'react-intl';

import { IWithContextProps, withContext } from '@tock/coretypes';
import React from 'react';

interface Props {
  displayWeekdayAs?: 'long' | 'short' | 'narrow';
  weekdayValue: number;
}

/**
 * Displays a weekday in the business locale.
 */
class DisplayWeekdayNoContext extends React.Component<Props & IWithContextProps> {
  toDateObject = (localDate: LocalDate): Date => {
    return new Date(Date.UTC(localDate.year(), localDate.monthValue() - 1, localDate.dayOfMonth()));
  };

  render() {
    const {
      context: { locale },
      displayWeekdayAs,
      weekdayValue,
    } = this.props;

    // I don't think this should actually work but it mirrors what the
    // code used to do and will pass typechecks, so:
    const funkyLocaleOverrideProps = {
      locales: [locale],
    };
    const dayOfWeek = DayOfWeek.of(weekdayValue === 0 ? 7 : weekdayValue);
    const localDate = LocalDate.now().with(TemporalAdjusters.next(dayOfWeek));
    return (
      <FormattedDate
        {...funkyLocaleOverrideProps}
        timeZone="UTC"
        value={this.toDateObject(localDate)}
        weekday={displayWeekdayAs}
      />
    );
  }
}

export const DisplayWeekday = withContext(DisplayWeekdayNoContext);
